import React, {useState} from 'react';
import { useHistory } from 'react-router';
import { ADDITONAL_PREDEFINE_SECTIONS, DEFAULT_SECTION_DISPLAY_ORDER, DEFAULT_SECTION_NAMES, DEFAULT_SECTION_ORDER, TPLS_COLOR, SECTION_COLOR_CLASS, EDITOR_ALL_INONE_LINK, QUICK_EDITOR } from '../../constants/constants';
import DraggableIcon from '../../assets/images/draggable-icon.svg';
import ArrowLeftIcon from '../../assets/images-new/icons/reorder-arrow-left.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { useResume } from '../../context/ResumeContext';
import '../../assets/fonts/backup/icomoon.scss';
import '../../assets/scss/common/_reorder.scss';
const RearrangeSectionsComponent = (props) => {
    const { 
        resume,
        handlers: {
            updateResumePreview,
            onsaveResume
        },
     } = useResume();
    const history = useHistory();
  // use state for open color dropdown list
  const RearrangedClick = (event) => {
    event.preventDefault();
    setOpenColorList(!openColorList);
    gaTrack('RT App', `Quick Editor`, 'Color Dropdown');
    ga4Track('app_quick_editor_color', 'RT App', 'Color Dropdown');
  }

  const displayOrder = () => {

    let toshow = [], strt
    if(resume?.sections_display_order && resume?.sections_display_order.length){
        strt = [...resume?.sections_display_order]
        //In case any core sectons are missed and also not skipped. This might happen
        const missing = DEFAULT_SECTION_DISPLAY_ORDER.filter(name => 
            (resume.sections_display_order.indexOf(name) == -1 && 
            resume.skipped_sections.indexOf(name) == -1 ))
            strt = strt.concat(missing)
    }else strt = DEFAULT_SECTION_DISPLAY_ORDER
   //Check all addtional sections  and if not list
    Object.keys(ADDITONAL_PREDEFINE_SECTIONS).map(v => {
        if(strt.indexOf(v) == - 1 && resume.hasOwnProperty(v)) strt = strt.concat(v)
      })
    //Check all custom sections in list and if not list
    resume?.additional_sections.custom.forEach(v => {
        (strt.indexOf(v) == -1 ) && (strt = strt.concat(v))
    })
    //Skipped should be removed from list
    strt.forEach(v => {
        if(resume.hasOwnProperty(v)){
            //name flaw in name, hack for educaton section
            if(v=='education_history' && !(resume.skipped_sections && resume.skipped_sections.includes('education')))
                toshow = toshow.concat(v);
            else if(v!='education_history' && !(resume.skipped_sections && resume.skipped_sections.includes(v)))
                toshow = toshow.concat(v);
        }
    })
    return toshow
  }

  const onDragEnd = result => {
    // TODO: reorder our column
    const { destination, source, draggableId } = result;
    if (!destination) return
    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    let ids = displayOrder(), all = []
    const i = [...ids]
      ids.splice(source.index, 1)
      ids.splice(destination.index, 0, draggableId)
      
      updateResumePreview(
          {
            sections_display_order: [ ...ids ]
          }
      )
      onsaveResume()
}

    return (
        <div className="reorder-controls">
           { props.popupView ? '' : <div className="reorder-top">
                <p className="reorder-back-to-forms" onClick={() => {
                    props.hasOwnProperty('showRearrange') ? props?.setShowRearrange(!props?.showRearrange) : history.push(QUICK_EDITOR);
                }

                }>
                    <i className="icon-back"><ArrowLeftIcon /></i> <span>Back to forms</span>
                </p>

                <p className="reorder-top-note">Rearrange section by dragging</p>
            </div> }
        <DragDropContext onDragEnd={onDragEnd}>
                <div className="reorder-listing-wrapper">
                <Droppable droppableId={'unrelavent'} >
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {displayOrder().map((section_id, index) => {
                                const row_name = DEFAULT_SECTION_NAMES.hasOwnProperty(section_id) ? DEFAULT_SECTION_NAMES[section_id] : resume[section_id]?.name
                                return (
                                    <Draggable draggableId={section_id} index={index} key={section_id}>
                                        {(provided, snapshot) => (
                                            <div className="reorder-listing-row drag-list"
                                                {...provided.draggableProps}
                                                ref={provided.innerRef}
                                                key={section_id}
                                                onClick={
                                                    (e) => {
                                                    }
                                                }>
                                                <div className="row-title" dataid={section_id} {...provided.dragHandleProps}>
                                                    {/* <h2 data-index={index + 1}>{row_name}</h2> */}
                                                    <div className={`reorder-block-name ${SECTION_COLOR_CLASS[section_id] ?? 'orange-line'}`} data-index={index + 1}>
                                                        <div type="button" className="btn btn-link">
                                                            <DraggableIcon />
                                                        </div>
                                                        <div className="reorder-block-name-inner">
                                                            {row_name}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        </DragDropContext>
      </div>
    );
}

export default RearrangeSectionsComponent;